import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import Header from "./Header";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import BrochureFab from "@/components/BrochureFab";
import SponsorProposalSlideIn from "@/components/SponsorProposalSlideIn";
import Seo from "@/components/Seo";
import { fbTrack } from "@/lib/pixel";
import { getSeo, organizationLd, websiteLd, eventLd, breadcrumbLd, faqLd, HOME_FAQS } from "@/lib/seo";

export default function Layout() {
  const { pathname } = useLocation();
  const meta = getSeo(pathname);

  // SPA PageView: base pixel fires PageView on first load; fire on subsequent route changes only.
  const firstLoad = useRef(true);
  useEffect(() => {
    if (firstLoad.current) { firstLoad.current = false; return; }
    fbTrack("PageView");
  }, [pathname]);

  // Skip global Seo on dynamic insight articles — they set their own.
  const isArticle = pathname.startsWith("/insights/") && pathname !== "/insights";

  const jsonLd = meta
    ? [
        organizationLd(),
        websiteLd(),
        eventLd(),
        breadcrumbLd(pathname),
        pathname === "/" ? faqLd(HOME_FAQS) : null,
      ]
    : [];

  return (
    <div className="min-h-screen bg-parchment">
      {meta && !isArticle && (
        <Seo
          title={meta.title}
          description={meta.description}
          keywords={meta.keywords}
          path={pathname}
          noindex={meta.noindex}
          jsonLd={jsonLd}
        />
      )}
      <ScrollToTop />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <BrochureFab />
      <SponsorProposalSlideIn />
    </div>
  );
}
